import { render, staticRenderFns } from "./DomainModal.vue?vue&type=template&id=c9b60f24"
import script from "./DomainModal.vue?vue&type=script&lang=js"
export * from "./DomainModal.vue?vue&type=script&lang=js"
import style0 from "./DomainModal.vue?vue&type=style&index=0&id=c9b60f24&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports